import React from "react"
import noop from "lodash/noop"

/**
 * Приспосабливает любой инпут (например из uikit)
 * к работе в качестве component у Field
 *
 * Функция getProps позволяет сгенерировать пропы на основе
 * meta и input от redux form
 */
export const fieldWrapper = Input => ({
  input,
  meta,
  getProps = noop,
  ...restProps
}) => <Input {...input} {...restProps} {...getProps(meta, input)} />
